const MAX_DISPLAYED_UNREAD = 99;

export const formatUnreadCount = (count: number): string =>
  count > MAX_DISPLAYED_UNREAD ? `${MAX_DISPLAYED_UNREAD}+` : String(count);
